var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParallelClusterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -168.41,
    y1: 746.33,
    x2: -168.41,
    y2: 596.33,
    gradientTransform: "matrix(-0.71, -0.71, -0.71, 0.71, 393.12, -556.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8511b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f90"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Product-Name") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Categories_and_Colors",
    "data-name": "Categories and Colors"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Orange_Gradient",
    "data-name": "Orange Gradient",
    y: 0.13,
    width: 75,
    height: 75,
    style: {
      fill: "url(#linear-gradient)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Working"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.13,
    y: 9.63,
    width: 54,
    height: 56,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.12,
    width: 75,
    height: 75,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Guides"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 65,
    height: 65,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.49,48.6a1,1,0,0,1-.43-.1c-4.17-2-7.25-5.55-10.24-9s-6-6.87-9.82-8.42a1,1,0,0,1-.55-1.3,1,1,0,0,1,1.3-.56c4.3,1.74,7.5,5.41,10.58,9,2.85,3.28,5.8,6.68,9.6,8.5a1,1,0,0,1-.44,1.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3,50.12a11.83,11.83,0,0,1-9.78-4.65,11.21,11.21,0,0,1-1.85-9.84,1,1,0,1,1,1.91.57,9.31,9.31,0,0,0,1.54,8.07,9.87,9.87,0,0,0,8.18,3.85c6.67,0,10.46-4.43,14.47-9.13,4.54-5.31,9.23-10.8,18.34-10.8a10.32,10.32,0,0,1,8.49,3.95,11.62,11.62,0,0,1,1.71,10,1,1,0,0,1-1.92-.55A9.57,9.57,0,0,0,62,33.35a8.22,8.22,0,0,0-6.89-3.16c-8.19,0-12.38,4.91-16.82,10.1C34.16,45.13,29.89,50.12,22.3,50.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,32H13a1,1,0,0,1-1-1V21a1,1,0,0,1,1-1h3a1,1,0,0,1,0,2H14v8h8V29a1,1,0,0,1,2,0v2A1,1,0,0,1,23,32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,26H20a1,1,0,0,1-1-1V15a1,1,0,0,1,1-1H30a1,1,0,0,1,1,1V25A1,1,0,0,1,30,26Zm-9-2h8V16H21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,56H60a1,1,0,0,1,0-2h1V46H53v2a1,1,0,0,1-2,0V45a1,1,0,0,1,1-1H62a1,1,0,0,1,1,1V55A1,1,0,0,1,62,56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,62H46a1,1,0,0,1-1-1V51a1,1,0,0,1,1-1H56a1,1,0,0,1,1,1V61A1,1,0,0,1,56,62Zm-9-2h8V52H47Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParallelClusterIcon);
export default __webpack_public_path__ + "static/media/parallel-cluster-icon.607c29bf5aaa9f664f80cbc195eac609.svg";
export { ForwardRef as ReactComponent };